module.exports = __webpack_public_path__ + "static/media/low.c208bdb7.svg";